import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';
import { yandexReachGoal, googleEvent } from 'cityads-v3/utils/counterUtils';

import { getRegions, getCategories } from 'cityads-v3/actions/offers';
import { getActionTypeDirections } from 'cityads-v3/actions/actionTypeDirections';
import { getContactTypes } from 'cityads-v3/actions/contactTypes';
import { getTimeZones } from 'cityads-v3/actions/timeZones';
import { getTrafficTypes } from 'cityads-v3/actions/trafficTypes';
import { getWebmasterTypes } from 'cityads-v3/actions/webmasterTypes';
import {
  clearErrorMessages,
  loadRegistrationSteps,
  loadUserRegistrationStep,
  loadWebmasterInfo,
  loadWebmasterAdditionalData,
} from 'cityads-v3/actions/welcomeform';

import {
  WEBMASTER_TYPE_PUBLISHER,
  WEBMASTER_TYPE_MEDIABUYER,
  WEBMASTER_TYPE_NETWORK,
} from 'cityads-v3/reducers/welcomeform';

import Balaclava from 'cityads-v3/components/Balaclava';
import TemporaryRedirect from 'cityads-v3/components/Router/TemporaryRedirect';

import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Step from '@mui/material/Step';
import Stepper from '@mui/material/Stepper';
import StepLabel from '@mui/material/StepLabel';

import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';

import classes from './WelcomeForm.scss';

export const ANALYTICS_EVENTS = {
  1: 'OPEN_WFSTEP1',
  2: 'OPEN_WFSTEP2',
  3: 'OPEN_WFSTEP3',
  4: 'OPEN_WFSTEP4',
  finish: 'CLICK_WFSTEP4_BUTTON_COMPLETE'
}

export const MAX_DISPLAYED_SELECTED = 4;

export const menuProps = {
  MenuProps:{
    MenuListProps:{
      dense: true
    }
  }
}

export const WEBMASTER_TYPES = t => [{
  label: t('WEBMASTER_TYPE_PUBLISHER'),
  description: t('webmaster_types.WEBMASTER_TYPE_PUBLISHER'),
  value: WEBMASTER_TYPE_PUBLISHER
}, {
  label: t('WEBMASTER_TYPE_MEDIABUYER'),
  description: t('webmaster_types.WEBMASTER_TYPE_MEDIABUYER'),
  value: WEBMASTER_TYPE_MEDIABUYER
}, {
  label: t('WEBMASTER_TYPE_NETWORK'),
  description: t('webmaster_types.WEBMASTER_TYPE_NETWORK'),
  value: WEBMASTER_TYPE_NETWORK
}];

export const formItemIconSx = theme => ({
  color: theme.palette.text.primary,
  position: 'absolute',
  left: '0',
  top: '18px',
  width: '24px',
  height: '24px',
})

@connect(state => ({
  curPage: state.welcomeform.curPage,
  language: state.language.language,
  isMobile: state.app.isMobile,

  isLoggedIn: state.auth.isLoggedIn,
  user: state.auth.user,
  checkingAuth: state.auth.checkingAuth,
  needWelcomeForm: state.welcomeform.need_welcome_form,

  isLoadedActionTypeDirections: state.actionTypeDirections.isLoaded,
  isLoadedCategories: state.offers.isLoadedCategories,
  isLoadedContactTypes: state.contactTypes.isLoaded,
  isLoadedRegions: state.offers.isLoadedRegions,
  isLoadedTimeZones: state.timeZones.isLoaded,
  isLoadedTrafficTypes: state.trafficTypes.isLoaded,
  isLoadedWebmasterTypes: state.webmasterTypes.isLoaded,

  registrationSteps: state.welcomeform.registrationSteps,
  isLoadedRegistrationSteps   : state.welcomeform.isLoadedRegistrationSteps,
  isLoadedUserRegistrationStep: state.welcomeform.isLoadedUserRegistrationStep,
  isLoadingWebmasterInfoForm       : state.welcomeform.isLoadingWebmasterInfoForm,
  isLoadingWebmasterAdditionalForm : state.welcomeform.isLoadingWebmasterAdditionalForm,
}))
@withTranslation(['Welcome', 'main'], { i18n, wait: !!window })
export default class WelcomeForm extends Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired,

    curPage: PropTypes.number,
    language: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    user: PropTypes.object,
    checkingAuth: PropTypes.bool,
    needWelcomeForm: PropTypes.bool,
    isMobile: PropTypes.bool,

    isLoadedActionTypeDirections: PropTypes.bool,
    isLoadedCategories: PropTypes.bool,
    isLoadedContactTypes: PropTypes.bool,
    isLoadedRegions: PropTypes.bool,
    isLoadedTimeZones: PropTypes.bool,
    isLoadedTrafficTypes: PropTypes.bool,
    isLoadedWebmasterTypes: PropTypes.bool,

    registrationSteps: PropTypes.array,
    isLoadedRegistrationSteps: PropTypes.bool,
    isLoadedUserRegistrationStep: PropTypes.bool,
    isLoadingWebmasterInfoForm: PropTypes.bool,
    isLoadingWebmasterAdditionalForm: PropTypes.bool,
  }

  state = {
    analyticsEvents: {
      1: false,
      2: false,
      3: false,
      4: false,
      finish: false,
    }
  }

  componentDidMount() {
    const { dispatch } = this.props;

    if (this.props.isLoadedRegistrationSteps) {
      dispatch(loadUserRegistrationStep());
    } else {
      dispatch(loadRegistrationSteps())
        .then(() => dispatch(loadUserRegistrationStep()))
      ;
    }

    if (!this.props.isLoadedActionTypeDirections) {
      dispatch(getActionTypeDirections());
    }

    if (!this.props.isLoadedRegions) {
      dispatch(getRegions());
    }

    if (!this.props.isLoadedContactTypes) {
      dispatch(getContactTypes());
    }

    if (!this.props.isLoadedCategories) {
      dispatch(getCategories());
    }

    if (!this.props.isLoadedTimeZones) {
      dispatch(getTimeZones());
    }

    if (!this.props.isLoadedWebmasterTypes) {
      dispatch(getWebmasterTypes());
    }

    if (!this.props.isLoadedTrafficTypes) {
      dispatch(getTrafficTypes());
    }

    this.loadWebmasterForms();

    this.analyticsSendEvent(1);
  }

  componentWillUnmount() {
    this.props.dispatch(clearErrorMessages())
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const oldProps = this.props;
    const { dispatch, language, curPage, user } = newProps;

    if (language !== oldProps.language) {
      dispatch(loadRegistrationSteps());
      dispatch(getActionTypeDirections());
      dispatch(getRegions());
      dispatch(getContactTypes());
      dispatch(getCategories());
      dispatch(getTimeZones());
      dispatch(getWebmasterTypes());
      dispatch(getTrafficTypes());
    }

    if (oldProps.curPage !== curPage) {
      this.analyticsSendEvent(curPage);
    }

    if (user?.id !== oldProps.user?.id) {
      this.loadWebmasterForms(newProps);
    }
  }

  loadWebmasterForms(props = this.props) {
    const { dispatch, user, isLoadingWebmasterInfoForm, isLoadingWebmasterAdditionalForm } = props;

    if (!user || !user.id) {
      return;
    }

    if (!isLoadingWebmasterInfoForm) {
      dispatch(loadWebmasterInfo(user.id));
    }

    if (!isLoadingWebmasterAdditionalForm) {
      dispatch(loadWebmasterAdditionalData(user.id));
    }
  }

  analyticsSendEvent(page) {
    if (!this.state.analyticsEvents[page]) {
      yandexReachGoal(ANALYTICS_EVENTS[page]);
      googleEvent('WelcomeForm', ANALYTICS_EVENTS[page]);
      this.setState({
        analyticsEvents: {
          ...this.state.analyticsEvents,
          [page]: true
        }
      });
    }
  }

  render() {
    const {
      curPage,
      t,
      isLoggedIn,
      needWelcomeForm,
      checkingAuth,
      isMobile,
      registrationSteps,
      isLoadedRegistrationSteps,
      isLoadedUserRegistrationStep,
      isLoadingWebmasterInfoForm,
      isLoadingWebmasterAdditionalForm,
    } = this.props;

    if (checkingAuth) {
      return (
        <div className={classes.toolsWait}>
          <CircularProgress size={40} />
        </div>
      );
    }

    if (!isLoggedIn) {
      return (
        <TemporaryRedirect to="/main" />
      );
    }

    if (needWelcomeForm === false) {
      return (
        <TemporaryRedirect to="/main" />
      );
    }

    if (
      !isLoadedRegistrationSteps ||
      !isLoadedUserRegistrationStep ||
      isLoadingWebmasterInfoForm ||
      isLoadingWebmasterAdditionalForm
    ) {
      return (
        <div className={classes.toolsWait}>
          <CircularProgress size={40} />
        </div>
      );
    }

    const curStep = registrationSteps[curPage - 1];

    return (
      <>
        <Helmet>
          <title>{t('main:welcome')}</title>
        </Helmet>

        <Balaclava
          title = {t('main:welcome')}
        />

        <div className={classes.page}>
          <Paper classes={{root: classes.stepContainer}}>
            {!isMobile && (
              <Stepper
                className={classes.stepper}
                activeStep={curPage - 1}
              >
                {registrationSteps.map(step => (
                  <Step key={step.code}><StepLabel>{step.name}</StepLabel></Step>
                ))}
              </Stepper>
            )}

            {(curStep.code === 'personal_settings') && <Step1/>}
            {(curStep.code === 'contacts') && <Step2/>}
            {(curStep.code === 'traffic_info') && <Step3/>}
            {(curStep.code === 'account_settings') && <Step4/>}

          </Paper>
        </div>
      </>
    );
  }
}
